module.exports = __webpack_public_path__ + "img/three-bean-salad.7c7b47d7.jpg";